import axios from "axios";
export function getApi(url, auth, tokenName, tokenValue, data){

    var headObject = {'content-type': 'application/json'};

    if(auth != null){
        Object.assign(headObject, {"Auth" : auth});
    }

    if(tokenName != null){
        Object.assign(headObject, {tokenName : tokenValue});
    }

    return axios({
        url: url,
        method: 'GET',
        headers: headObject,
        data: data||{}//需加上空data否則 headers不會動作
    })
}

export function postApi(url, auth, tokenName, tokenValue, data){

    var headObject = {'content-type': 'application/json'};

    if(auth != null){
        Object.assign(headObject, {"Auth" : auth});
    }

    if(tokenName != null){
        Object.assign(headObject, {tokenName : tokenValue});
    }

    return axios({
        url: url,
        method: 'POST',
        headers: headObject,
        data: data||{}//需加上空data否則 headers不會動作
    })
}

export function downloadFile(url, auth, data){
    return axios({
        url: url,
        method: 'GET',
        headers: { "Authorization": auth,},
        responseType: 'blob',
        data: data||{}//需加上空data否則 headers不會動作
    })
}

export function uploadFile(url, auth, data){
    return axios({
        url:url,
        method: 'POST',
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': auth
        },
        data: data
    })
}